import React from 'react';

function clientRandomizer(props) {
  const millsAds = [
    {
      image: '/dvmf-2022/sponsors/altabank.jpg',
      link: 'https://www.altabank.com',
      alt: 'Deer Valley Musical Festival Season lineup',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2022/sponsors/grandeur-peaks-heart-hill.jpg',
      alt: 'Grandeur Peaks and Heart Hill',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2022/sponsors/Classical-89.jpg',
      link: 'https://www.classical89.org',
      alt: 'Classical 89',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2022/sponsors/eccles-foundation.jpg',
      link: 'https://www.gsecclesfoundation.org/',
      alt: 'Eccles Foundation',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2022/sponsors/ghostlight.jpg',
      link: 'https://soundcloud.com/utahsymphony',
      alt: 'Ghostlight Podcast',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2022/sponsors/education.jpg',
      link: 'https://www.deervalleymusicfestival.org/',
      alt: 'DVMF Education information',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2022/sponsors/holland-hart.jpg',
      link: 'https://www.hollandhart.com/',
      alt: 'Holland & Hart',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2022/sponsors/share-us.jpg',
      alt: 'Utah Symphony social media call out',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2022/sponsors/st-regis.jpg',
      link: 'https://www.marriott.com/en-us/hotels/slcxr-the-st-regis-deer-valley/overview/',
      alt: 'St. Regis',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2022/sponsors/summit.jpg',
      link: 'https://www.summitsothebysrealty.com',
      alt: 'Summit Sothebys',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2022/sponsors/terry-final.jpg',
      link: 'https://www.utahsymphony.org',
      alt: 'Thierry Fischers final USUO season',
      class: 'webFormat',
    },
    {
      image: '/dvmf-2022/sponsors/zions-bank.jpg',
      link: 'https://www.zionsbank.com',
      alt: 'Zions Bank',
      class: 'webFormat',
    },
  ];

  const randomAd = millsAds[Math.floor(Math.random() * millsAds.length)];

  return (
    <>
      <hr />
      <br />
      <a href={randomAd.link} target="_blank" rel="noopener noreferrer">
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </a>
      <br />
      <br />
      <hr />
    </>
  );
}

export default clientRandomizer;
